import { render } from "./DaoTokens.vue?vue&type=template&id=7b8998fe&scoped=true"
import script from "./DaoTokens.vue?vue&type=script&lang=js"
export * from "./DaoTokens.vue?vue&type=script&lang=js"

import "./DaoTokens.vue?vue&type=style&index=0&id=7b8998fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8998fe"]])

export default __exports__